import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { DContext } from "../../../context/Datacontext";
import { fetchSyllbus } from "../../../services/coures/fetchSyllbus";
import { findCourse } from "../../../services/coures/findCourse";
import { createSyllabus } from "../../../services/coures/createSyllabus";
import { fetchSyllabusData } from "../../../services/coures/fetchSyllabusData";
import { fetchSession } from "../../../services/coures/fetchSession";
import { Syllabus } from "../../../components/blocks/Syllabus";
import { fetchUpdateSession } from "../../../services/coures/fetchUpdateSession";
import { Loader } from "../../../components/common/Loader";
import { IoClose } from "react-icons/io5";
import { makeRemoteFile } from "../../../utils/makeRemoteFile";
import { FaAngleLeft } from "react-icons/fa";
import { FaAngleRight } from "react-icons/fa";
import { MdFolder } from "react-icons/md";


export const CourseContent = () => {
  const { BeURL , setLoading , loading} = useContext(DContext);

  /* ---------------- STATES ---------------- */
  const [departmentChips, setDepartmentChips] = useState([]);
  const [findCourseChips, setFindCourseChips] = useState([]);

  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [activeSyllabus, setActiveSyllabus] = useState(null);

  const [syllabusData, setSyllabusData] = useState([]);


  const [syllabusTitle, setSyllabusTitle] = useState("");
  const [orderNumber, setOrderNumber] = useState("");

  const [openSyllabusModal, setOpenSyllabusModal] = useState(false);

  /* loading / feedback states */
  const [loadingDepartments, setLoadingDepartments] = useState(false);
  const [loadingCourses, setLoadingCourses] = useState(false);
  const [loadingSyllabus, setLoadingSyllabus] = useState(false);
  const [creatingSyllabus, setCreatingSyllabus] = useState(false);
    const [activeSession, setActiveSession] = useState(null);
    const [loadingSession, setLoadingSession] = useState(false);

    const [updateSession,setUpdateSession]=useState([])

  /* upload session modal */
  const [activeUploadSession, setActiveUploadSession] = useState(false);
  const [actionChange,setActionChange]=useState(false)

  /* sections state used inside upload modal */
  const [sectionName, setSectionName] = useState("");
  const [sections, setSections] = useState([]);

  const scrollRef = useRef(null);
  const activeRef = useRef(null);

  // 👉 Auto scroll active tab into view
  useEffect(() => {
    if (activeRef.current) {
      activeRef.current.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [selectedCourse]);

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -200, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 200, behavior: "smooth" });
  };

  /* ---------------- FETCH DEPARTMENTS ---------------- */
  const fetchDepartments = useCallback(async () => {
    try {
      setLoadingDepartments(true);
      const res = await fetchSyllbus({ BeURL });
      if (res?.success) {
        setDepartmentChips(res.departmentChips || []);
      } else {
        setDepartmentChips([]);
      }
    } catch (err) {
      console.error("fetchDepartments error:", err);
      setDepartmentChips([]);
    } finally {
      setLoadingDepartments(false);
    }
  }, [BeURL]);

  useEffect(() => {
    fetchDepartments();
  }, [fetchDepartments]);

  /* ---------------- AUTO SELECT FIRST DEPARTMENT ---------------- */
  useEffect(() => {
    if (departmentChips.length > 0) {
      const firstDept = departmentChips[0].value;
      setSelectedDepartment(firstDept);
      // fetch courses for that department
      handleFindCourse(firstDept);
    } else {
      setSelectedDepartment(null);
      setFindCourseChips([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [departmentChips]);



  /* ---------------- FETCH COURSES ---------------- */
  const handleFindCourse = useCallback(
    async (departmentId) => {
      if (!departmentId) return;

      setSelectedDepartment(departmentId);
      setSelectedCourse(null);
      setFindCourseChips([]);
      setActiveSyllabus(null);

      try {
        setLoadingCourses(true);
        const res = await findCourse({ BeURL, departmentId });
        if (res?.success) {
          setFindCourseChips(res.courseChips || []);
          // auto-select first course after fetching
          if (res.courseChips && res.courseChips.length > 0) {
            const firstCourse = res.courseChips[0].value;
            setSelectedCourse(firstCourse);
          }
        } else {
          setFindCourseChips([]);
        }
      } catch (err) {
        console.error("handleFindCourse error:", err);
        setFindCourseChips([]);
      } finally {
        setLoadingCourses(false);
      }
    },
    [BeURL]
  );

  /* when selectedCourse changes fetch syllabus list */
  useEffect(() => {
    if (selectedCourse && selectedDepartment) {
      handleFetchSyllabus(selectedCourse);
    } else {
      setSyllabusData([]);
      setActiveSyllabus(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCourse, selectedDepartment]);

  /* ---------------- FETCH SYLLABUS ---------------- */
  const handleFetchSyllabus = useCallback(
    async (courseId) => {
      if (!courseId || !selectedDepartment) return;

      setLoadingSyllabus(true);
      setActiveSyllabus(null);

      try {
        const res = await fetchSyllabusData({
          BeURL,
          departmentId: selectedDepartment,
          courseId,
        });

        if (res?.success) {
          const list = Array.isArray(res.syllabus) ? res.syllabus : [];
          // sort by order for display
          const sorted = [...list].sort(
            (a, b) => (a.syllabus?.order || 0) - (b.syllabus?.order || 0)
          );
          setSyllabusData(sorted);
          setActiveSyllabus(sorted.length > 0 ? sorted[0] : null);
        } else {
          setSyllabusData([]);
        }
      } catch (err) {
        console.error("handleFetchSyllabus error:", err);
        alert("Server error");
      } finally {
        setLoadingSyllabus(false);
      }
    },
    [BeURL, selectedDepartment]
  );

  /* ---------------- CREATE SYLLABUS ---------------- */
  const handleCreateSyllabus = useCallback(async () => {
    if (!selectedDepartment || !selectedCourse) {
      alert("Select Department & Course");
      return;
    }

    if (!syllabusTitle.trim()) {
      alert("Enter syllabus title");
      return;
    }

    if (orderNumber === "" || Number.isNaN(Number(orderNumber))) {
      alert("Enter valid order number");
      return;
    }

    try {
      setCreatingSyllabus(true);
      const payload = {
        BeURL,
        departmentId: selectedDepartment,
        courseId: selectedCourse,
        title: syllabusTitle.trim(),
        order: Number(orderNumber),
      };

      const data = await createSyllabus(payload);

      if (data?.success) {
        alert("Syllabus created successfully ✅");
        // clear form
        setSyllabusTitle("");
        setOrderNumber("");
        setOpenSyllabusModal(false);
        // refresh syllabus list
        handleFetchSyllabus(selectedCourse);
      } else {
        alert(data?.message || "Failed to create syllabus");
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    } finally {
      setCreatingSyllabus(false);
    }
  }, [BeURL, selectedCourse, selectedDepartment, syllabusTitle, orderNumber, handleFetchSyllabus]);

  /* ---------------- UPLOAD SESSION ---------------- */
  const handleUploadSession = (item) => {
    setActiveSyllabus(item);
    // reset modal state each time user opens
    setSectionName("");
    setSections([]);
    setActiveUploadSession(true);
    setActionChange(false)
  };



 




  const handleAddSection = () => {
    if (!sectionName.trim()) return;

    setSections((prev) => [
      ...prev,
      {
        order: prev.length + 1,
        name: sectionName,
        type: "video",
        description: "",
        files: [],
      },
    ]);

    setSectionName("");
  };

  const updateSection = (index, key, value) => {
    setSections((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [key]: value };
      return updated;
    });
  };

  const handleFileUpload = (index, files) => {
    setSections((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], files: Array.from(files) };
      return updated;
    });
  };



 
    const handleSubmitSyllabusUploads = async () => {

      setLoading(true)

        if (!activeSyllabus) {
            alert("Select a syllabus before uploading");
            return;
        }

        if (sections.length === 0) {
            alert("Add at least one section");
            return;
        }

        const formData = new FormData();

        /* ✅ SEND METADATA AS STRING */
        const meta = sections.map((s) => ({
            order: s.order,
            name: s.name,
            type: s.type,
            description: s.description,
        }));

        formData.append("metadata", JSON.stringify(meta));

        /* ✅ SEND FILES */
        sections.forEach((s, si) => {
            (s.files || []).forEach((f, fi) => {

                formData.append(
                    `section_${si}_file_${fi}`,
                    f,
                    f.name
                );

            });

        });

        try {

            const resp = await fetch(
                `${BeURL}/syllabus/${activeSyllabus._id}/upload-multi`,
                {
                    method: "POST",
                    body: formData,
                    credentials: "include",
                }
            );

            const data = await resp.json();

            if (data?.success) {
                alert("Upload successful");
                setActiveUploadSession(false);
                handleFetchSyllabus(selectedCourse);

            } else {
                alert(data?.message);
            }

        } catch (err) {
            console.error("upload error:", err);
            alert("Server error during upload");
        }
        finally {

          // Always stop loader (success / error / return)
          setLoading(false);

        }

    };

 


    // call this from your session click: onClick={() => handlefetchVideo(session._id)}
    const handlefetchVideo = async (sessionOrId) => {
        const id = typeof sessionOrId === "string" ? sessionOrId : sessionOrId?._id;

        if (!id || !BeURL) {
            alert("Invalid data");
            return;
        }

        try {
            setLoadingSession(true);

            // call your fetch util (which calls GET /fetch-session?id=...)
            const res = await fetchSession({ BeURL, id });

            if (res?.success && res.session) {
                setActiveSession(res.session);

                // optionally set active syllabus if session has syllabusId and you want UI to reflect it
                // const parent = syllabusData.find(s => s._id === res.session.syllabusId?.toString());
                // if (parent) setActiveSyllabus(parent);

            } else {
                alert(res?.message || "Failed to load session");
            }
        } catch (err) {
            console.error(err);
            alert("Server error");
        } finally {
            setLoadingSession(false);
        }
    };


  const handleFetchUpdateSession = async (sessionId) => {
    try {
      const res = await fetchUpdateSession({ BeURL, item: sessionId });

      if (!res?.success) {
        alert(res?.message);
        return;
      }

      const session = res.data;

      console.log("fech uodate sesssion" , session)
      setActiveUploadSession(true);
      setActionChange(true)

      setUpdateSession(session)
    } catch (err) {
      console.error("handleFetchUpdateSession error", err);
    }
  };

  useEffect(() => {
    if (!updateSession) return;

    const session = {
      name: updateSession.title ?? "",
      type: updateSession.type ?? "video",
      description: updateSession.description ?? "",
      files: updateSession.file ? [makeRemoteFile(updateSession.file ,BeURL)] : [],
      _id: updateSession._id,
    };
    setSections([session]);
  }, [updateSession, BeURL]);


  const handleUpdateSession = async () => {
    if (!updateSession) {
      alert("No session selected for update");
      return;
    }

    if (!sections || sections.length === 0) {
      alert("No section data to update");
      return;
    }

    setLoading(true);

    try {
      const s = sections[0]; // update single session

      const formData = new FormData();

      /* ✅ SEND METADATA */
      formData.append("name", s.name);
      formData.append("description", s.description || "");
      formData.append("type", s.type);
      formData.append("order", s.order);

      /* ✅ SEND FILE ONLY IF USER CHANGED */
      const newFiles = (s.files || []).filter(
        (f) => f instanceof File
      );

      if (newFiles.length > 0) {
        formData.append("file", newFiles[0], newFiles[0].name);
      }

      const resp = await fetch(
        `${BeURL}/session/${updateSession._id}`,
        {
          method: "PUT",
          body: formData,
          credentials: "include",
        }
      );

      const data = await resp.json();

      if (!resp.ok || !data?.success) {
        throw new Error(data?.message || "Update failed");
      }

      alert("Session updated successfully");

      /* ✅ RESET + REFRESH */
      setActiveUploadSession(false);
      setUpdateSession(null);
      handleFetchSyllabus(selectedCourse);

    } catch (err) {
      console.error("Update error:", err);
      alert(err.message || "Server error during update");
    } finally {
      setLoading(false);
    }
  };



  const handleApprovelSession = async (department, course) => {
    if (!department || !course) {
      alert("Department & Course required");
      return;
    }

    const params = new URLSearchParams({
      department,
      course
    });

    try {
      const res = await fetch(
        `${BeURL}/approval-session?${params.toString()}`,
        {
          method: "GET",
          credentials: "include"
        }
      );

      const data = await res.json();

      if (!res.ok || !data.success) {
        alert(data.message || "Approval failed");
        return;
      }

      alert("Approval session created successfully");
    } catch (err) {
      console.error(err);
      alert("Server error");
    }
  };






  /* ---------------- UI HELPERS ---------------- */
  const openCreateSyllabusModal = () => {
    setSyllabusTitle("");
    setOrderNumber("");
    setOpenSyllabusModal(true);
  };


  if(loading){
    return <Loader />
  }

  return (
    <div className="bg-gray-50 min-h-screen p-6 space-y-6">
      {/* HEADER */}
      <h2 className="text-xl font-semibold text-gray-800">Course Curriculum</h2>
      {/* DEPARTMENT TABS */}
      <div className="flex gap-6 border-b">
        {loadingDepartments ? (
          <div className="text-sm text-gray-400 py-3">Loading departments...</div>
        ) : (
          departmentChips.map((dep) => (
            <button
              key={dep.value}
              onClick={() => handleFindCourse(dep.value)}
              className={`pb-2 text-sm font-medium transition overflow-x-auto ${selectedDepartment === dep.value
                ? "border-b-2 border-primary-600 text-primary-600"
                : "text-gray-500 hover:text-primary-600"
                }`}
            >
              {dep.label}
            </button>
          ))
        )}
      </div>

      {/* COURSE TABS */}
      {/* <div className="flex gap-6 border-b mt-4">
        {loadingCourses ? (
          <div className="text-sm text-gray-400 py-3">Loading courses...</div>
        ) : findCourseChips.length > 0 ? (
          findCourseChips.map((course) => (
            <button
              key={course.value}
              onClick={() => setSelectedCourse(course.value)}
              className={`pb-2 text-sm font-medium transition overflow-x-auto ${selectedCourse === course.value
                ? "border-b-2 border-secondary-600 text-secondary-600"
                : "text-gray-500 hover:text-secondary-600"
                }`}
            >
              {course.label}
            </button>
          ))
        ) : (
          <p className="text-sm text-gray-400 py-3">Select department</p>
        )}
      </div> */}

      <div className="relative border-b mt-4">

        {/* ⬅️ Left Arrow */}
        <button
          onClick={scrollLeft}
          className="absolute left-0 top-1/2 -translate-y-1/2 z-20
                    p-1 hidden sm:flex"
        >
          <FaAngleLeft />
        </button>

        {/* ➡️ Right Arrow */}
        <button
          onClick={scrollRight}
          className="absolute right-0 top-1/2 -translate-y-1/2 z-20
                    p-1 hidden sm:flex"
        >
          <FaAngleRight />
        </button>

        {/* ✨ Gradient fades */}
        <div className="pointer-events-none absolute left-0 top-0 h-full w-8
                       z-10" />

        {/* Tabs */}
        <div
          ref={scrollRef}
          className="
          flex gap-6
          overflow-x-auto
          whitespace-nowrap
          scrollbar-hide
          px-8
          relative
        "
        >
          {loadingCourses ? (
            <div className="text-sm text-gray-400 py-3">
              Loading courses...
            </div>
          ) : findCourseChips.length > 0 ? (
            findCourseChips.map((course) => {
              const isActive = selectedCourse === course.value;

              return (
                <button
                  key={course.value}
                  ref={isActive ? activeRef : null}
                  onClick={() => setSelectedCourse(course.value)}
                  className="
                  relative pb-3 text-sm font-medium
                  flex-shrink-0 transition-colors
                "
                >
                  <span
                    className={
                      isActive
                        ? "text-secondary-600"
                        : "text-gray-500 hover:text-secondary-600"
                    }
                  >
                    {course.label}
                  </span>

                  {/* 🎯 Animated underline */}
                  {isActive && (
                    <span
                      className="
                      absolute left-0 right-0 -bottom-[1px]
                      h-[2px] bg-secondary-600
                      rounded-full
                      transition-all duration-300
                    "
                    />
                  )}
                </button>
              );
            })
          ) : (
            <p className="text-sm text-gray-400 py-3">
              Select department
            </p>
          )}
        </div>
      </div>

      {/* MAIN CONTENT */}
           <div>
            <Syllabus
              syllabusData={syllabusData}
              loadingSyllabus={loadingSyllabus}
              activeSession={activeSession}
              loadingSession={loadingSession}
              BeURL={BeURL}
              handleUploadSession={handleUploadSession}
              handlefetchVideo={handlefetchVideo}
              handlefetchUpdateSession={handleFetchUpdateSession}
              openCreateSyllabusModal={openCreateSyllabusModal}
            />
           </div>

          <div className=" flex justify-end">
        <button onClick={()=>handleApprovelSession(selectedDepartment,selectedCourse)} className="px-4 font-semibold py-2 bg-primary-600 text-white rounded-xl">Submit for Approval</button>
          </div>


      {/* CREATE MODAL */}
      {openSyllabusModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">

          {/* Modal Box */}
          <div className="w-full max-w-2xl max-h-[90vh] overflow-y-auto
                    bg-white rounded-2xl shadow-2xl
                    animate-[fadeIn_0.25s_ease-out]">

            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b">

              <div>
                <h3 className="text-lg font-semibold text-gray-800">
                  Create Curriculum
                </h3>
                <p className="text-xs text-gray-500 mt-0.5">
                  Setup department, course and syllabus details
                </p>
              </div>

              <button
                onClick={() => setOpenSyllabusModal(false)}
                className="p-2 rounded-lg hover:bg-gray-100 transition"
              >
                <IoClose size={18} />
              </button>

            </div>

            {/* Body */}
            <div className="px-6 py-5 space-y-6">

              {/* Department */}
              <div>
                <label className="text-sm font-medium text-gray-700">
                  Department
                </label>

                <div className="flex flex-wrap gap-2 mt-2 p-3 rounded-xl border bg-gray-50">

                  {departmentChips.length > 0 ? (
                    departmentChips.map((dep) => {
                      const isActive = selectedDepartment === dep.value;

                      return (
                        <span
                          key={dep.value}
                          onClick={() => handleFindCourse(dep.value)}
                          className={`px-3 py-1.5 rounded-full text-sm cursor-pointer transition-all
                      ${isActive
                              ? "bg-primary-600 text-white shadow"
                            : "bg-primary-100 text-primary-600 hover:bg-primary-200"
                            }`}
                        >
                          {dep.label}
                        </span>
                      );
                    })
                  ) : (
                    <p className="text-gray-400 text-sm">
                      No department available
                    </p>
                  )}

                </div>
              </div>

              {/* Courses */}
              <div>
                <label className="text-sm font-medium text-gray-700">
                  Course
                </label>

                <div className="flex flex-wrap gap-2 mt-2 p-3 rounded-xl border bg-gray-50">

                  {findCourseChips.length > 0 ? (
                    findCourseChips.map((course) => {
                      const isActive = selectedCourse === course.value;

                      return (
                        <span
                          key={course.value}
                          onClick={() => setSelectedCourse(course.value)}
                          className={`px-3 py-1.5 rounded-full text-sm cursor-pointer transition-all
                      ${isActive
                            ? "bg-secondary-500 text-white shadow"
                            : "bg-secondary-100 text-secondary-500 hover:bg-secondary-200"
                            }`}
                        >
                          {course.label}
                        </span>
                      );
                    })
                  ) : (
                    <p className="text-gray-400 text-sm">
                      No courses available
                    </p>
                  )}

                </div>
              </div>

              {/* Title */}
              <div>
                <label className="text-sm font-medium text-gray-700">
                  Syllabus Title
                </label>

                <input
                  value={syllabusTitle}
                  onChange={(e) => setSyllabusTitle(e.target.value)}
                  placeholder="Eg: React Fundamentals"
                  className="w-full mt-1 px-3 py-2.5 rounded-lg border
                       focus:ring-2 focus:ring-secondary-200 
                       outline-none text-sm transition"
                />
              </div>

              {/* Order */}
              <div>
                <label className="text-sm font-medium text-gray-700">
                  Display Order
                </label>

                <input
                  type="number"
                  value={orderNumber}
                  onChange={(e) => setOrderNumber(e.target.value)}
                  placeholder="Eg: 1"
                  className="w-full mt-1 px-3 py-2.5 rounded-lg border
                       focus:ring-2 focus:ring-secondary-200 outline-none text-sm transition"
                />
              </div>

            </div>

            {/* Footer */}
            <div className="flex items-center justify-end gap-3 px-6 py-4 border-t bg-gray-50 rounded-b-2xl">

              <button
                onClick={() => setOpenSyllabusModal(false)}
                disabled={creatingSyllabus}
                className="px-4 py-2 text-sm rounded-lg border
                     hover:bg-gray-100 transition
                     disabled:opacity-50"
              >
                Cancel
              </button>

              <button
                onClick={handleCreateSyllabus}
                disabled={creatingSyllabus}
                className="px-5 py-2 text-sm font-medium rounded-lg text-white
                     bg-gradient-to-r from-primary-400 to-primary-500
                     hover:from-primary-500 hover:to-primary-600
                     shadow-md hover:shadow-lg transition-all
                     disabled:opacity-60"
              >
                {creatingSyllabus ? "Creating..." : "Create Curriculum"}
              </button>

            </div>

          </div>
        </div>
      )}


      {/* UPLOAD SESSIONS MODAL */}
      {activeUploadSession && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">

          {/* Modal */}
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white w-full max-w-4xl max-h-[90vh] overflow-y-auto rounded-2xl shadow-2xl"
          >

            {/* ================= HEADER ================= */}
            <div className="sticky top-0 bg-white z-10 border-b px-6 py-4 flex justify-between items-center">

              <div>
                <h3 className="text-xl font-bold text-gray-800">
                  Upload Course Sessions
                </h3>

                <p className="text-sm text-gray-500">
                  Module: {activeSyllabus?.syllabus?.title}
                </p>
              </div>

              <div className="flex gap-2">

                <button onClick={() => setActiveUploadSession(false)}>
                  <IoClose /> 
                </button>
              </div>

            </div>



            {/* ================= BODY ================= */}
            <div className="p-6 space-y-6">


              {/* ADD SECTION */}
              <div className="bg-slate-50 rounded-xl p-4 border">
                <div className="flex flex-col md:flex-row gap-3">
                  <input
                    type="text"
                    placeholder="Eg: Installation, Basics, API Setup..."
                    value={sectionName}
                    onChange={(e) => setSectionName(e.target.value)}
                    className="flex-1 border rounded-lg px-4 py-2 focus:ring-2 focus:ring-secondary-200 outline-none"
                  />
                  <button
                    onClick={handleAddSection}
                    className=" text-primary-500 font-semibold hover:text-primary-600"
                  >
                    + Add
                  </button>

                </div>

              </div>



              {/* ================= SECTIONS ================= */}
              <div className="space-y-5">

                {sections.map((section, sIndex) => (

                  <div
                    key={sIndex}
                    className="bg-white border rounded-2xl shadow-sm p-5 space-y-3"
                  >

                    {/* Section Header */}
                    <div className="flex flex-wrap justify-between items-center gap-3">

                      {/* <div className="flex items-center gap-3">
                        <div>
                          <p className="text-sm font-semibold text-gray-700">
                            Section {section.order}
                          </p>

                          <p className="text-xs text-gray-500">
                            {section.name}
                          </p>
                        </div>

                      </div> */}


                      {/* Remove */}
                      {/* <button
                        onClick={() =>
                          setSections(prev => prev.filter((_, i) => i !== sIndex))
                        }
                        className="text-red-500 text-sm hover:underline"
                      >
                        Remove
                      </button> */}

                    </div>



                    {/* FORM GRID */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

                      <div className="md:col-span-2">

                        <label className="text-xs text-gray-500">Title</label>

                        <input
                          type="text"
                          value={section.name}
                          onChange={(e) =>
                            updateSection(sIndex, "name", e.target.value)
                          }
                          className="w-full border rounded-lg px-3 py-2 mt-1 focus:ring-2 focus:ring-secondary-200 outline-none"
                        />
                      </div>

                      {/* TYPE */}
                      <div>

                        <label className="text-xs text-gray-500">
                          Content Type
                        </label>

                        <select
                          value={section.type}
                          onChange={(e) =>
                            updateSection(sIndex, "type", e.target.value)
                          }
                          className="w-full border rounded-lg px-3 py-2 mt-1 focus:ring-2 focus:ring-secondary-200 outline-none"
                        >

                          <option value="video">🎥 Video</option>
                          <option value="document">📄 Document</option>
                          <option value="image">🖼️ Image</option>
                          <option value="description">📝 Text Only</option>

                        </select>

                      </div>

                    </div>







                    {/* DESCRIPTION */}
                    <div>

                      <label className="text-xs text-gray-500">
                        Description
                      </label>

                      <textarea
                        rows={3}
                        value={section.description}
                        onChange={(e) =>
                          updateSection(sIndex, "description", e.target.value)
                        }
                        placeholder="Explain what this section contains..."
                        className="w-full border rounded-lg px-3 py-2 mt-1 resize-none focus:ring-2 focus:ring-secondary-200 outline-none"
                      />

                    </div>



                    {/* FILE UPLOAD */}
                    {section.type !== "description" && (

                      <div className="bg-slate-50 border-dashed border-2 border-secondary-300 rounded-xl p-4 text-center">

                        <label className="cursor-pointer block">

                          <input
                            type="file"
                            multiple
                            hidden
                            accept={
                              section.type === "video"
                                ? "video/*"
                                : section.type === "image"
                                  ? "image/*"
                                  : ".pdf,.doc,.docx"
                            }
                            onChange={(e) =>
                              handleFileUpload(sIndex, e.target.files)
                            }
                          />
                           
                      <div className="grid justify-center">
                            <p className="text-sm text-gray-600 flex items-center gap-1">
                              <span><MdFolder /></span> Click to upload files
                            </p>

                            <p className="text-xs text-gray-400 mt-1">
                              Drag & drop supported
                            </p>
                      </div>

                        </label>

                      </div>

                    )}



                    {/* FILE LIST */}
                    {section.files?.length > 0 && (

                      <div className="bg-secondary-50 rounded-lg p-3">

                        <p className="text-xs font-semibold text-primary-600 mb-2">
                          Uploaded Files
                        </p>

                        <ul className="text-sm text-gray-600 space-y-1">

                          {section.files.map((f, i) => (

                            <li
                              key={i}
                              className="flex items-center gap-2"
                            >
                              <span className="truncate">
                                {f.name}
                              </span>

                            </li>

                          ))}

                        </ul>

                      </div>

                    )}


                  </div>

                ))}

                {/* Footer */}
                <div className="flex items-center justify-end gap-3 px-6 py-4 border-t bg-gray-50 rounded-b-2xl">

                  <button
                    onClick={() => setActiveUploadSession(false)}
                    className="px-4 py-2 border rounded-lg text-sm hover:bg-gray-100"
                  >
                    Cancel
                  </button>

                  {!actionChange ? (
                    < button
                      onClick={handleSubmitSyllabusUploads}
                      className="px-4 py-2 bg-primary-500 text-white rounded-lg text-sm hover:bg-primary-600 flex items-center gap-1"
                    >
                      Save
                    </button>
                  ) : (
                    < button
                      onClick={handleUpdateSession}
                      className="px-4 py-2 bg-primary-500 text-white rounded-lg text-sm hover:bg-primary-600 flex items-center gap-1"
                    >
                      Update Save
                    </button>
                  )
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
